export const CreativeStatus = {
    Approved: {
        label: 'Approved',
        key: 'Approved',
        icon: 'StatusDot',
        color: '#46862d',
        size: 15
    },
    Rejected: {
        label: 'Rejected',
        key: 'Rejected',
        icon: 'StatusDot',
        color: '#a20201',
        size: 15
    },
    Pending: {
        label: 'Awaiting Approval',
        key: 'Pending',
        icon: 'StatusDotOutline',
        color: '#46862d'
    },
    Ready: {
        label: 'Ready',
        key: 'Ready',
        icon: 'StatusDotOutline',
        color: '#46862d'
    },
    Processing: {
        label: 'Processing',
        key: 'Processing',
        icon: 'StatusDot',
        color: '#989898',
        size: 15
    },
}
